var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delivery",class:{'has-background-warning py-2': this.$route.path == '/checkout'}},[_c('div',{staticClass:"label mb-0"},[_vm._v("Prossima data "+_vm._s(_vm.labelConsegna))]),_c('div',[_vm._v(_vm._s(_vm.tomorrowDate))])])}
var staticRenderFns = []

export { render, staticRenderFns }